module.exports = __webpack_public_path__ + "static/media/bg_price_engine.d6ec9976.png";